__turbopack_context__.v({
  "bannerHalf": "HeroWithSplitBanner-module__43XmFq__bannerHalf",
  "buttonText": "HeroWithSplitBanner-module__43XmFq__buttonText",
  "buttonWrapper": "HeroWithSplitBanner-module__43XmFq__buttonWrapper",
  "container": "HeroWithSplitBanner-module__43XmFq__container",
  "contentWrapper": "HeroWithSplitBanner-module__43XmFq__contentWrapper",
  "headingWrapper": "HeroWithSplitBanner-module__43XmFq__headingWrapper",
  "heroSection": "HeroWithSplitBanner-module__43XmFq__heroSection",
  "imageWrapper": "HeroWithSplitBanner-module__43XmFq__imageWrapper",
  "splitBannerSection": "HeroWithSplitBanner-module__43XmFq__splitBannerSection",
  "splitTextContainer": "HeroWithSplitBanner-module__43XmFq__splitTextContainer",
  "splitTextItem": "HeroWithSplitBanner-module__43XmFq__splitTextItem",
  "stickyContainer": "HeroWithSplitBanner-module__43XmFq__stickyContainer",
  "stickyWrapper": "HeroWithSplitBanner-module__43XmFq__stickyWrapper",
  "styledImage": "HeroWithSplitBanner-module__43XmFq__styledImage",
  "textWrapper": "HeroWithSplitBanner-module__43XmFq__textWrapper",
  "titleWrapper": "HeroWithSplitBanner-module__43XmFq__titleWrapper",
});
